/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Order_Export_Creator_LabelInputs */

const vi_order_export_creator_label = /** @type {(inputs: Order_Export_Creator_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Người tạo`)
};

/**

* @param {Order_Export_Creator_LabelInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const order_export_creator_label = /** @type {((inputs?: Order_Export_Creator_LabelInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Order_Export_Creator_LabelInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_order_export_creator_label(inputs)
});